import { APIStatus } from "@application/common/enums/api-status";
import { createSlice } from "@reduxjs/toolkit";
import { createUserAsync, updateUserAsync, getAllUsersAsync, getUserByIdAsync, updateUserStatusAsync, updateMultipleUserStatusAsync, getUsersByProposalAsync, } from "./userThunk";
const initialState = {
    status: APIStatus.IDLE,
    users: {
        items: [],
        pageNumber: 0,
        totalPages: 0,
        totalCount: 0,
        hasPreviousPage: false,
        hasNextPage: false,
    },
    selectedUser: null,
    apiError: undefined,
};
export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        resetUserState: (state) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        },
        clearSelectedUser: (state) => {
            state.selectedUser = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllUsersAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllUsersAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.users = action.payload;
        })
            .addCase(getAllUsersAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createUserAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.users) {
                // state.users.items.push(action.payload);
            }
        })
            .addCase(createUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateUserAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.users) {
                const index = state.users.items.findIndex((u) => u.id === action.payload.id);
                if (index !== -1) {
                    state.users.items[index] = {
                        ...state.users.items[index],
                        ...action.payload,
                    };
                }
            }
        })
            .addCase(updateUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUserByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUserByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedUser = action.payload;
        })
            .addCase(getUserByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUsersByProposalAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUsersByProposalAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.usersByDesignation = action.payload;
        })
            .addCase(getUsersByProposalAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateUserStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateUserStatusAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(updateUserStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateMultipleUserStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateMultipleUserStatusAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(updateMultipleUserStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    },
});
export const { resetUserState, clearSelectedUser } = userSlice.actions;
export default userSlice.reducer;
